import { Divider, Table } from "antd";
export default function ListViews(props) {

    const { list_views = [] } = props;

    const columns = [
        { title: <small>Rank</small>, dataIndex: 'list', key: 'list', width: 210, },
        {
            title: <small>Views</small>, dataIndex: 'views', key: 'views', width: 10, render: (e) => {
                return <div style={{ "textAlign": "right" }}>{e}</div>
            }
        },
        {
            title: <small>Carted</small>, dataIndex: 'carted', key: 'carted', width: 10, render: (e) => {
                return <div style={{ "textAlign": "right" }}>{e}</div>
            }
        },
    ]


    const data = list_views.map(item => {
        return {
            list: item.list_name,
            views: item.view_count || 0,
            carted: item.carted_count || 0,
        }
    })


    return (
        <>
            <strong className="c" style={{ "fontSize": "13px" }}>List views</strong>
            <div style={{ "fontSize": "14px" }}><small>Breakdown of list views by popularity</small></div>
            <Divider dashed style={{ "margin": "10px 0px" }} />
            <Table bordered size="small" dataSource={data.sort((a, b) => b.views - a.views)} columns={columns} />
        </>
    )

}